import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';

/**
 * CPS-7434: The "Sale" item in the top navigation is highlighted in red as an
 * Amplitude A/B experiment ({@link Flags.SALE_NAV_RED}). Contentful has no
 * dedicated field to mark the item, so per product we identify it by its link
 * URL. We match "sale" as a delimited path segment (ignoring query/hash) so
 * that incidental matches like "/wholesale" or "?utm_campaign=summer-sale" do
 * not turn the wrong item red or enroll it into the experiment.
 */
export const isSaleLink = (href?: string): boolean => {
  if (!href) return false;
  const path = href.toLowerCase().split(/[?#]/)[0];
  return /(^|[/-])sale([/-]|$)/.test(path);
};

/**
 * Tailwind classes for the red Sale-link treatment. Colors are the Cloud
 * Foundations dark-palette values from the ticket (the top nav renders light
 * text on a dark background). Arbitrary values keep the experiment self
 * contained so it is trivial to remove once the test concludes.
 */
export const SALE_NAV_RED_CLASSES = 'text-[#FF9592] hover:text-[#EC5D5E]';

/** Whether the red Sale-link treatment is active for the current user. */
export const useSaleNavRedTreatment = (): boolean => {
  const { flags } = useFlags();
  return flags?.[Flags.SALE_NAV_RED]?.value === FLAG_TREATMENT;
};
